<template>


  <CCard>
    <CCardHeader class="card-detail-header">
      <slot name="header">
        <span class="card-detail-header-title">
          <CIcon name="cil-info" /> Detalle
          <strong v-if="!isExtraPayment">
            {{ stringUtils.getProductLabel(productCard.product_type) }}
            <span v-if="productCard.product_type === 'prepago'"> - {{ productCard.plan.name }} </span>
          </strong>
        </span>
        <CButton color="primary" @click="goToDetail">Ver producto</CButton>
      </slot>
    </CCardHeader>

    <CCardBody>
      <CListGroup>

        <CListGroupItem v-if="isCustomPayment" class="d-flex justify-content-between align-items-center">
          <strong>Concepto</strong>
          <span v-if="productCard.custom_text">{{ productCard.custom_text }}</span>
        </CListGroupItem>

        <CListGroupItem class="d-flex justify-content-between align-items-center">
          <strong>Fecha inicio</strong>
          <span v-if="productCard">{{ formatDateCustom(productCard.start_datetime) }}</span>
        </CListGroupItem>

        <CListGroupItem class="d-flex justify-content-between align-items-center">
          <strong>Fecha fin</strong>
          <span v-if="productCard">{{ formatDateCustom(productCard.end_datetime) }}</span>
        </CListGroupItem>

        <CListGroupItem class="d-flex justify-content-between align-items-center">
          <strong>Hora inicio</strong>
          <span v-if="productCard">
            {{ stringUtils.timeFormat(productCard.start_datetime) }}
          </span>
        </CListGroupItem>

        <CListGroupItem class="d-flex justify-content-between align-items-center">
          <strong>Hora fin</strong>
          <span v-if="productCard">{{ stringUtils.timeFormat(productCard.end_datetime) }} </span>
        </CListGroupItem>

        <CListGroupItem class="d-flex justify-content-between align-items-center">
          <strong>Importe</strong>
          <span>{{ productCard.amount }} €</span>
        </CListGroupItem>

        <CListGroupItem v-if="productCard.discount" class="d-flex justify-content-between align-items-center">
          <strong>Descuento</strong>
          <span> 
            <span class="mr-4" style="color: gray">({{ productCard.discount }} %)</span>
            {{ productCard.discount_amount }} €
          </span>
        </CListGroupItem>

        <CListGroupItem class="d-flex justify-content-between align-items-center">
          <strong>Total</strong>
          <span> {{ productCard.total_amount }} € </span>
        </CListGroupItem>
      </CListGroup>
    </CCardBody>
  </CCard>


</template>

<script>

import BadgePaymentStatus from '@/components/badges/BadgePaymentStatus';
import stringUtils from '@/app/shared/utils/stringUtils';
import { formatDateTimeCustom, formatDateCustom } from '@/app/shared/utils/utils';

export default {
  name: 'CardPaymentProductDetail',
  components: {
    BadgePaymentStatus
  },
  props: {
    elemento: { type: String, default: 'Plan'},
    title: String,
    loading: Boolean,
    product: { type: Object, default: {}, required: true },
    payment: { type: Object  },
    paymentStatus: {type: String, default: '' }
  },
  data() {
    return {
      stringUtils: stringUtils,
      formatDateTimeCustom: formatDateTimeCustom,
      formatDateCustom: formatDateCustom,
    }
  },
  computed:{
    productCard: function () {
      return {...this.product}
    },
    paymentCard: function () {
      return {...this.payment}
    },
    isExtraPayment() {
      return this.productCard?.product_type === 'extra' ? true : false;
    },
    isCustomPayment() {
      return this.productCard?.product_type === 'custom' ? true : false;
    }
  },
  methods:{
    getUrlPlanContract(planType, parkingId){
      const url = planType === 'prepago' ? `/gestion/contrataciones/${parkingId}` :
       planType === 'base' ? `/gestion/contrataciones_por_minuto/${parkingId}` :
       planType === 'custom' ? `/gestion/contrataciones_custom/${parkingId}` : ''

      return url
    },


    getTypeProduct(item) {

      // Payment product_type = base, prepago, custom, extra
      // Productos product_type = perminutes, prepago, custom, extra

      // TODO: actualizar el api y en frontales a perminutes, unificar prefijo (base/perminutes)

      const productType = item.product_type === 'base' ? `perminutes` : item.product_type;

      return `${item.id}?data=${productType}`;
    },


    goToDetail() {

      // El id del plan contratado no es el id del plan.
      // Los planes contratados están en tabla parkings_plans_clients. Un plan de un parking contratado por un cliente
      // Los planes disponibles están en la tabla plans.
      // Los planes de un parking están en la tabla parkings_plans

      // console.log(this.productCard.plan.id);  // Es el id del plan, ejemplo zapatillas azules talla 25
      // console.log(this.productCard); // Es el producto contratado. con id propio, tabla independiente

      // Datos mock para ir a un plan contratado del cliente logueado
      // const planesContratados = this.productFinishedList.concat(this.productActiveList).concat(this.productNotActiveList);

      this.$router.push(`/gestion/contrataciones/${this.getTypeProduct(this.productCard)}`);
    },
  }
}
</script>
